module.exports = __webpack_public_path__ + "img/system_view.96e2909e.jpg";